// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","701":"homeM"}[chunkId] + "." + {"177":"97bcc72f","701":"a1509864"}[chunkId] + ".js";
};